const IdReader = {
    getQuestionId(editorInstance) {
        return editorInstance.element.$.getAttribute('data-questionId');
    },

    getInteractionId(editorInstance) {
        return editorInstance.element.$.getAttribute('data-interactionId');
    },
};

export default IdReader;
